import React, { useMemo, useState } from "react";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { CtaBlock } from "@/components/CtaBlock";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { track } from "@/lib/analytics";

export default function Faq() {
  const { data: faqs = [] } = useQuery({ queryKey: ["faqs"], queryFn: () => api.get("/faqs").then((r) => r.data) });
  const [cat, setCat] = useState(null);
  const cats = useMemo(() => [...new Set(faqs.map((f) => f.category))], [faqs]);
  const filtered = cat ? faqs.filter((f) => f.category === cat) : faqs;

  const jsonLd = faqs.length ? {
    "@context": "https://schema.org", "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.question, acceptedAnswer: { "@type": "Answer", text: f.answer } })),
  } : null;

  return (
    <>
      <Seo title="FAQ — Domande frequenti su SENIORCAR"
        description="Risposte alle domande più frequenti su SENIORCAR: prezzo, patente, dispositivo medico, agevolazioni, ricarica, prova e garanzia."
        keywords="faq seniorcar, serve la patente, quanto costa seniorcar" jsonLd={jsonLd} />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "FAQ" }]} /></div>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 pt-6">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight" style={{ fontFamily: "Outfit" }}>Domande frequenti</h1>
        <p className="mt-4 text-lg sm:text-xl text-slate-600">Le risposte alle domande più comuni su SENIORCAR.</p>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex gap-2 flex-wrap mb-6">
          <button onClick={() => setCat(null)} className={`px-4 py-2 rounded-full text-sm font-semibold border ${!cat ? "text-white border-transparent" : "text-slate-700 border-slate-300 bg-white"}`} style={!cat ? { backgroundColor: "var(--sc-emerald)" } : {}}>Tutte</button>
          {cats.map((c) => (
            <button key={c} onClick={() => setCat(c)} className={`px-4 py-2 rounded-full text-sm font-semibold border ${cat === c ? "text-white border-transparent" : "text-slate-700 border-slate-300 bg-white"}`} style={cat === c ? { backgroundColor: "var(--sc-emerald)" } : {}} data-testid={`faq-cat-${c}`}>{c}</button>
          ))}
        </div>
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {filtered.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="rounded-2xl bg-white border border-slate-200 px-5">
              <AccordionTrigger className="text-left text-lg font-semibold text-slate-900 hover:no-underline py-5" onClick={() => track("faq_open", { q: f.question })} data-testid={`faq-item-${i}`}>{f.question}</AccordionTrigger>
              <AccordionContent className="text-slate-600 text-base leading-relaxed pb-5">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 pb-16"><CtaBlock variant="test" /></section>
    </>
  );
}
